export default __webpack_public_path__ + "static/media/linkedin.8cac5173.svg";